import React, {Component}  from 'react';
import IconButton from 'material-ui/IconButton';
import icon from 'images/actioniconapple.png';
import AddCircle from 'material-ui/svg-icons/content/add-circle';
import isLocalStorageSupported from 'utils/local-storage';


const style = {
    main: {
    },
    icon: {
        color: '#db1f2b',
        fontSize: 27
    },
    iconButton: {
        color: '#00A7F7',
        position: 'absolute',
        padding: 0,
        top: -5,
        right: -5,
        cursor: 'pointer',
        transform: 'rotate(45deg)'
    }
};

const userAgent = navigator.userAgent;
const isSupportedDevice = /iphone/i.test(userAgent) && ! /crios/i.test(userAgent) && isLocalStorageSupported();
const isStandalone = navigator.standalone;
const sawPopup = (localStorage.getItem('disableAddToHomeScreen') === 'true');

class AddToHome extends Component {

    constructor(props) {
        super(props);
        const isVisible = isSupportedDevice && !isStandalone &&
            !sawPopup;

        this.state = { isVisible };
    }

    close() {
        if (isLocalStorageSupported()) {
            localStorage.setItem('disableAddToHomeScreen', 'true');
        }
        this.setState({ isVisible: false});
    }

    render() {
        let mainStyle  = this.state.isVisible ? style.main : Object.assign({}, style.main, {display: 'none'});
        return <div className="wt-add-to-home" style={mainStyle}>
            <IconButton className="fill-with-white" style={style.iconButton} iconStyle={style.icon} >
                <AddCircle onTouchTap={this.close.bind(this)}></AddCircle>
            </IconButton>
            Install this web app on your iPhone for the best experience. Tap &nbsp;
            <img src={icon} style={{width: 20}} role="presentation"/> and then "Add to Home Screen".
        </div>;
    }
}

export default AddToHome;